import {
  validateAlpha,
  validateEmail,
  validatePhoneNumber,
} from "../generalValidators.ts";

export const personalReferenceValidators = {
  name_1: validateAlpha,
  first_last_name_1: validateAlpha,
  second_last_name_1: validateAlpha,
  phone_1: validatePhoneNumber,
  email_1: validateEmail,
  name_2: validateAlpha,
  first_last_name_2: validateAlpha,
  second_last_name_2: validateAlpha,
  phone_2: validatePhoneNumber,
  email_2: validateEmail,
};
